import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Icon from "@material-ui/core/Icon/Icon";
import InputBase from "@material-ui/core/InputBase/InputBase";
import {withStyles} from "@material-ui/core/styles/index";

class SearchField extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchQuery: props.value,
        };
    }

    handleChange(e) {
        this.setState({
            searchQuery: e.target.value
        });
    }

    handleDoSearch(e) {
        e.preventDefault();
        this.props.doSearch(
            this.state.searchQuery
        );
    }

    render() {
        let classes = this.props.classes;
        return (
            <div className={classes.search}>
                <form onSubmit={this.handleDoSearch.bind(this)}>
                    <div className={classes.searchIcon}>
                        <Icon>search</Icon>
                    </div>
                    <TextField
                        type="text"
                        name="search"
                        className={classes.inputInput}
                        placeholder={this.props.label}
                        value={this.state.searchQuery}
                        onChange={this.handleChange.bind(this)}
                        title={this.props.title}
                    />
                </form>
            </div>
        );
    }
}

SearchField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    doSearch: PropTypes.func.isRequired,
};


const styles = theme => ({
    search: {
        position: 'relative',
        color: theme.colors.lightGreyBlue,
        float: "right",
    },
    searchIcon: {
        width: theme.spacing.unit * 3,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: theme.colors.lightGreyBlue,
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 6,
        transition: theme.transitions.create('width'),
    },
});

export default withStyles(styles)(SearchField);
